import React from "react";

interface IconcsCardProps {
  icon: string;
  label: string;
}

const IconcsCard: React.FC<IconcsCardProps> = ({ icon, label }) => {
  return (
    <div className="flex flex-col items-center justify-center w-32 h-32 p-4 transition-shadow border rounded-lg border-eventToBee hover:shadow-md">
      <img className="w-12 mb-2 text-2xl" src={icon} />
      <p className="text-xs font-medium text-center text-gray-800 dark:text-white">{label}</p>
    </div>
  );
};

export default IconcsCard;
export type { IconcsCardProps };
